import type { NextPage } from 'next'

import { Authorization } from 'src/modules/auth'

const MainPage: NextPage = () => {
  return <Authorization />
}

export default MainPage
